import { RangeSlider } from "@clintonelec/react-storybook";
import { produce } from "immer";
import type { MotionCameraState } from "Interfaces";
import { type Dispatch, Fragment, memo, type SetStateAction } from "react";

type VideoMotionControlsProps = {
	localMotionSettings: MotionCameraState;
	setLocalMotionSettings: Dispatch<SetStateAction<MotionCameraState>>;
};

function VideoMotionControls(props: VideoMotionControlsProps) {
	const {
		localMotionSettings, localMotionSettings: { daySensitivityLevel, nightSensitivityLevel }, setLocalMotionSettings
	} = props;

	const handleDaySensitivityOnChange = (value: number | number[]) => {
		if (Array.isArray(value)) {
			return;
		}

		setLocalMotionSettings(produce(localMotionSettings, draft => {
			draft.daySensitivityLevel = value;
		}));
	};

	const handleNightSensitivityOnChange = (value: number | number[]) => {
		if (Array.isArray(value)) {
			return;
		}

		setLocalMotionSettings(produce(localMotionSettings, draft => {
			draft.nightSensitivityLevel = value;
		}));
	};

	return (
		<Fragment>
			<div className="motion-setting-row">
				<span>Day Sensitivity</span>
				<div className="video-motion-object">
					<RangeSlider
						hideInputCharMessage
						inputDisplay
						min={ 0 }
						max={ 100 }
						onChange={ handleDaySensitivityOnChange }
						value={ daySensitivityLevel }
					/>
				</div>
			</div>
			<div className="motion-setting-row">
				<span>Night Sensitivity</span>
				<div className="video-motion-object">
					<RangeSlider
						hideInputCharMessage
						inputDisplay
						min={ 0 }
						max={ 100 }
						onChange={ handleNightSensitivityOnChange }
						value={ nightSensitivityLevel }
					/>
				</div>
			</div>
		</Fragment>
	);
}

export default memo(VideoMotionControls);
